<div class="order-actions-dialog">
  <mat-dialog-content class="mat-dialog-content">
    <div class="dialog-content">
      <mat-form-field appearance="outline" class="watch-order-select">
        <input
          #searchInput
          matInput
          class="alert-search-input"
          placeholder="Select a watch alert"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchTextChange($event)"
          [matAutocomplete]="watchAlertAuto"
        />
        <button
          class="dropdown-btn"
          mat-icon-button
          matSuffix
          type="button"
          cdkFocusInitial
          (mousedown)="$event.preventDefault(); openDropdown()"
        >
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
      </mat-form-field>
      <mat-autocomplete
        #watchAlertAuto="matAutocomplete"
        class="order-actions-panel"
        [autoActiveFirstOption]="false"
        [displayWith]="displayWatchAlert"
        (optionSelected)="onWatchAlertSelected($event)"
      >
        @for (watchAlert of filteredWatchAlerts; track watchAlert) {
        <mat-option [value]="watchAlert.id">
          <span
            [innerHTML]="highlightMatch(watchAlert.title, filterText)"
          ></span>
        </mat-option>
        }
      </mat-autocomplete>
      <button
        id="submit-order-action-btn"
        mat-flat-button
        class="copy-move-button"
        [disabled]="!selectedWatchAlert"
        [class.enabled]="selectedWatchAlert"
        (click)="onAction()"
        [matTooltip]="actionTooltip"
      >
        <mat-icon class="material-icons-outlined">{{ actionIcon }}</mat-icon>
      </button>
    </div>
  </mat-dialog-content>
</div>
